// tslint:disable
// This file is generated by buildArt script.
// Please don't edit it manually.
export var IdAssetBundleBuildingsInitial;
(function (IdAssetBundleBuildingsInitial) {
    IdAssetBundleBuildingsInitial["acre_1"] = "acre_1";
    IdAssetBundleBuildingsInitial["acre_seeds_corn_1"] = "acre_seeds_corn_1";
    IdAssetBundleBuildingsInitial["acre_seeds_corn_2"] = "acre_seeds_corn_2";
    IdAssetBundleBuildingsInitial["acre_seeds_corn_3"] = "acre_seeds_corn_3";
    IdAssetBundleBuildingsInitial["acre_seeds_wildflowers_1"] = "acre_seeds_wildflowers_1";
    IdAssetBundleBuildingsInitial["acre_seeds_wildflowers_2"] = "acre_seeds_wildflowers_2";
    IdAssetBundleBuildingsInitial["acre_seeds_wildflowers_3"] = "acre_seeds_wildflowers_3";
    IdAssetBundleBuildingsInitial["barn_1"] = "barn_1";
    IdAssetBundleBuildingsInitial["celebration_6x6"] = "celebration_6x6";
    IdAssetBundleBuildingsInitial["chickenCoop_1"] = "chickenCoop_1";
    IdAssetBundleBuildingsInitial["chickenCoop_1_fence"] = "chickenCoop_1_fence";
    IdAssetBundleBuildingsInitial["farmHouse_1"] = "farmHouse_1";
    IdAssetBundleBuildingsInitial["scaffolding_3x3"] = "scaffolding_3x3";
    IdAssetBundleBuildingsInitial["scaffolding_3x6"] = "scaffolding_3x6";
    IdAssetBundleBuildingsInitial["scaffolding_6x6"] = "scaffolding_6x6";
    IdAssetBundleBuildingsInitial["scaffolding_6x9"] = "scaffolding_6x9";
    IdAssetBundleBuildingsInitial["scaffolding_9x9"] = "scaffolding_9x9";
    IdAssetBundleBuildingsInitial["windmill_1"] = "windmill_1";
    IdAssetBundleBuildingsInitial["windmill_blades_1"] = "windmill_blades_1";
})(IdAssetBundleBuildingsInitial || (IdAssetBundleBuildingsInitial = {}));



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/IdAssetBundleBuildingsInitial.ts
// module id = 574
// module chunks = 3